import styled from "styled-components"


const AboutHero = () => {
    return (
      <div style={{ marginTop: "2rem" }}>
        <Wrapper>
          <h1>About Us</h1>
          <div>
            <p>Invest–Trust Limited is a timely provider of investment products and services that incorporates global best practices and modern technology in delivering absolute quality.</p>
          </div>
        </Wrapper>
      </div>
    );
}

export default AboutHero


export const Wrapper = styled.div`
  padding-top: 2rem;
  padding-bottom: 5rem;
  // transform: translateY(-2rem);
  background-image: url("https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651531019/invest-trust/section_b_fftu3z.svg");
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 5rem;
  width: 100%;
  h1 {
    padding-top: 2.5rem;
    text-align: center;
    font-size: 3rem;
    font-family: "Futura";
    font-weight: 200;
  }
  div {
    //   width: 100px;
  }
  div p {
    text-align: center;
    font-size: 1.25rem;
    width: 41.25rem;
    margin: auto;
  }

  @media screen and (max-width: 991px) {
    h1 {
      margin-left: 5rem;
      margin-right: 5rem;
      padding-top: 2.5rem;
      text-align: center;
      font-size: 2rem;
    }
    div p {
      text-align: center;
      font-size: 1.25rem;
      width: 70%;
      margin: auto;
      padding-bottom: 3.5rem;
    }
  }
  @media screen and (max-width: 579px) {
    padding-bottom: 2rem;
    h1 {
      margin-left: 2rem;
      margin-right: 2rem;
      padding-top: 0.5rem;
      text-align: center;
      font-size: 3rem;
    }
    div {
      width: 80%;
      margin: auto;
    }
    div p {
      text-align: center;
      font-size: 20px;
      width: 95%;
      margin: auto;
    }
  }
`;